import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import { urls } from '../settings/urls';

class GoogleAnalytics extends Component {
    componentWillUpdate ({ location, history }) {
        // console.log('changeee', urls.GA_TRACKING_ID, location);
        ReactGA.initialize(urls.GA_TRACKING_ID);
        ReactGA.pageview(location.pathname + location.search);
    }

    render () {
        return null;
    }
}

const GAnalytics = withRouter(GoogleAnalytics)
export { GAnalytics };